import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, ButtonBase, Select, MenuItem, Typography } from '@material-ui/core';
import NoMatch from '../../home/NoMatch'
import { MatchItem } from '.';
import Apis from '../../../network/Apis';
import MatchType from '../../../model/MatchType';
import Match from '../../../model/Match';
import DateUtils from '../../../control/dateutils';

class MatchTeamSchedule extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectIndex: 0,
            finished: 0,
            data: [],
            filterData: [],
        };
        console.log('MatchTeamSchedule', props);
    }

    componentDidMount() {
        this.getTeamMatch();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getTeamMatch = async () => {
        const { type_id } = this.props.location.data;
        const { competition_id, id } = this.props.data;
        let typ = competition_id;
        if (type_id == MatchType.BASKETBALL) {
            typ = undefined;
        }
        let result = await Apis.encryptionTeamMatch(type_id, id, typ);
        console.log('getTeamMatch', result);
        if (result.code == 200) {
            this.setState({ data: result.data }, () => {
                this._filterData();
            });
        }
    }

    _handleChange = (value) => {
        console.log('_handleChange', value);
        this.setState({ selectIndex: value }, () => {
            this._filterData();
        });
    }

    _onClickNotFinish = () => {
        this.setState({ finished: 0 }, () => {
            this._filterData();
        });
    }

    _onClickFinished = () => {
        this.setState({ finished: 1 }, () => {
            this._filterData();
        });
    }

    _filterData = () => {
        const { data, finished, selectIndex } = this.state;
        const { id } = this.props.data;
        let filterData = [];
        for (let i = 0; i < data.length; i++) {
            let match = new Match(data[i]);
            if (finished == 0) {
                if (match.notFinished()) {
                    if (selectIndex == 0) {
                        filterData.push(data[i]);
                    } else if (selectIndex == 1) {
                        if (data[i].home_team_id == id) {
                            filterData.push(data[i]);
                        }
                    } else if (selectIndex == 2) {
                        if (data[i].away_team_id == id) {
                            filterData.push(data[i]);
                        }
                    }
                }
            } else {
                if (match.finished()) {
                    if (selectIndex == 0) {
                        filterData.push(data[i]);
                    } else if (selectIndex == 1) {
                        if (data[i].home_team_id == id) {
                            filterData.push(data[i]);
                        }
                    } else if (selectIndex == 2) {
                        if (data[i].away_team_id == id) {
                            filterData.push(data[i]);
                        }
                    }
                }
            }
        }

        filterData = filterData.sort((a, b) => {
            return b.match_time - a.match_time;
        });

        this.setState({ filterData: filterData });
    }

    render() {
        const { classes } = this.props;
        const { selectIndex, finished, filterData } = this.state;
        return (
            <Grid style={{ width: '100%' }}>
                <Grid style={{ width: '100%', height: 1, backgroundColor: '#F2F2F2' }}></Grid>
                <Grid container direction='row' justifyContent='space-around' style={{ marginTop: 12, marginBottom: 12 }}>
                    <ButtonBase className={finished == 0 ? classes.button : classes.unselectButton} onClick={() => this._onClickNotFinish()}>未开赛</ButtonBase>
                    <ButtonBase className={finished == 1 ? classes.button : classes.unselectButton} onClick={() => this._onClickFinished()}>已结束</ButtonBase>
                </Grid>
                <Grid>
                    {
                        filterData.map((item, i) => (
                            <Grid key={i} container direction='row' justifyContent='center'>
                                <Grid container direction='row' justifyContent='center' alignItems='center' style={{ height: 30, backgroundColor: '#F2F2F2' }}>
                                    <Typography style={{ color: '#0D0D0D', fontSize: 10 }}>{DateUtils.dateFormatMD(item.match_time)}</Typography>
                                </Grid>
                                <Grid>
                                    <MatchItem line={false} data={item}></MatchItem>
                                </Grid>
                            </Grid>
                        ))
                    }
                </Grid>
                {
                    filterData.length == 0 && <Grid>
                        <NoMatch />
                    </Grid>
                }
                <Grid container direction='row' style={{ flex: 1, width: '100%', position: 'fixed', bottom: 0, boxShadow: '1px 1px 3px #F0F0F0' }}>
                    <ButtonBase onClick={() => this._handleChange(0)} className={selectIndex == 0 ? classes.selectedbottomButton : classes.unSelectedbottomButton}>全部</ButtonBase>
                    <ButtonBase onClick={() => this._handleChange(1)} className={selectIndex == 1 ? classes.selectedbottomButton : classes.unSelectedbottomButton}>主场</ButtonBase>
                    <ButtonBase onClick={() => this._handleChange(2)} className={selectIndex == 2 ? classes.selectedbottomButton : classes.unSelectedbottomButton}>客场</ButtonBase>
                    <ButtonBase onClick={() => this._handleChange(3)} className={selectIndex == 3 ? classes.selectedbottomButton : classes.unSelectedbottomButton}>筛选</ButtonBase>
                </Grid>
            </Grid >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    button: {
        fontSize: 12,
        backgroundColor: theme.palette.primary.main,
        color: '#FFF',
        borderRadius: 12.5,
        width: 75,
        height: 25,
    },
    unselectButton: {
        fontSize: 12,
        backgroundColor: '#E2E2E2',
        color: '#878787',
        borderRadius: 12.5,
        width: 75,
        height: 25,
    },
    unSelectedbottomButton: {
        fontSize: 14,
        backgroundColor: '#FFF',
        color: '#0D0D0D',
        width: '25vw',
        height: 50,
    },
    selectedbottomButton: {
        fontSize: 14,
        backgroundColor: theme.palette.primary.main,
        color: '#FFF',
        width: '25vw',
        height: 50,
    },
    tableBodyCell1: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        fontSize: 10,
        color: theme.palette.primary.main
    },
    tableBodyCell: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        fontSize: 10,
        color: '#0d0d0d'
    },
    icon: {
        width: 20,
        height: 20,
        marginLeft: 4,
        marginRight: 4,
    }
}))(MatchTeamSchedule));